import Header from 'Components/Layouts/Auth/Header';
import React from 'react';

import Footer from 'Components/Layouts/Footer';

import { Container } from 'Components/Utilities';

export default class Auth extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {
            children,
            showNav,
            headerImage,
            customHeader,
            containerWidth,
            containerPadding,
            contentClass = 'w-full flex-1 h-full bg-white',
        } = this.props;

        return (
            <div className="min-h-screen w-full flex flex-col">
                {showNav !== false && <Header />}

                {!customHeader && <div
                    className={`px-12 md:px-0 bg-cover h-1/3-screen ${showNav === false ? 'h-1/3-screen' : 'h-1/5-screen'}`}
                    style={{
                        backgroundImage: `url(${headerImage ?? '/images/default-header-bg.jpg'})`,
                    }}
                />}

                {customHeader}

                <div className={contentClass}>
                    <Container padding={containerPadding} maxWidth={containerWidth}>
                        {children}
                    </Container>
                </div>

                <Footer />
            </div>
        );
    }
}
